import getBenefits from "v2/infrastructure/Benefits/repositories";

const findBenefits = async ({
  companyId,
  benefitModelId,
}: {
  companyId: string;
  benefitModelId: string;
}) => {
  return getBenefits({ companyId, benefitModelId });
};

export default findBenefits;
